import React, {Component} from 'react';
import {FieldWrapper} from "../form-validator";
import PropTypes from 'prop-types';
import classNames from "classnames";

/**
 * Regular Select field, when Selectize does not work.
 */
class SelectField extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        const {name, setValue, postProcess} = this.props,
            value = e.target.value;
        setValue(name, value, postProcess);
    }

    render() {
        const {
            name, description, selectList,
            value,
            // Remove this from rest, so we don't send them to select tag
            setValue, postProcess, validationState, selectizeOptions, validations,
            ...rest
        } = this.props,
            {status, messages} = validationState || {},
            hasError = status === 'error' && Array.isArray(messages);
        return (
            <div className="form-group browser-default-group">
                <select
                    name={name}
                    className={classNames("form-control browser-default", {'is-invalid': hasError})}
                    value={value || ''}
                    onChange={this.onChange}
                    aria-describedby={"sr-" + name}
                    aria-invalid={hasError}
                    {...rest}
                >
                    {this.props.children}
                    {selectList.map(item => (
                        <option key={item.code} value={item.code}>{item.description}</option>
                    ))}
                </select>
                {description && (
                    <label htmlFor={name} className="active browser-default-label">
                        {description}
                    </label>)
                }
                <div key={"sr-" + name} id={"sr-" + name} className={classNames("error-message", {'invalid-feedback': hasError})}
                     aria-live="assertive" aria-hidden={hasError ? 'false' : 'true'}>
                    {
                        hasError && messages.map(
                            item => (
                                <div key={item}>
                                    {item}
                                </div>
                            ))
                    }
                </div>
            </div>
        );
    }
}

SelectField.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    postProcess: PropTypes.func,
    selectList: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
    }))
};

export default FieldWrapper(SelectField);
